import { create } from 'zustand';

export type ReadOnlyCode = 'workspace_suspended' | 'workspace_pending_deletion';

export interface ReadOnlyState {
  /** Set from the API's 403 when a write hits a read-only workspace; null while writes work. */
  workspaceId: string | null;
  code: ReadOnlyCode | null;
  /** Suspended by the billing scheduler for an unpaid invoice: the banner links to /billing (amendment 15). */
  billing: boolean;
  set: (s: { workspaceId: string | null; code: ReadOnlyCode; billing: boolean }) => void;
  clear: () => void;
}

export const useReadOnly = create<ReadOnlyState>()((set) => ({
  workspaceId: null,
  code: null,
  billing: false,
  set: ({ workspaceId, code, billing }) => set({ workspaceId, code, billing }),
  clear: () => set({ workspaceId: null, code: null, billing: false }),
}));

/** Reads the API's read-only refusal (`{ code, billing }`, plan §13.2) out of an error body; null for anything else. */
export function readOnlyFrom(body: unknown): { code: ReadOnlyCode; billing: boolean } | null {
  if (!body || typeof body !== 'object') return null;
  const b = body as { code?: unknown; billing?: unknown };
  if (b.code !== 'workspace_suspended' && b.code !== 'workspace_pending_deletion') return null;
  return { code: b.code, billing: b.code === 'workspace_suspended' && b.billing === true };
}
